var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"mask"},[_c('div',{staticClass:"content"},[_c('a-spin',{attrs:{"size":"large"}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text || '正在处理您的请求'))]),_c('div',{staticClass:"subtitle"},[_vm._v("请稍后，这个可能需要几秒钟")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }